import { render, staticRenderFns } from "./StaffSelect.vue?vue&type=template&id=748bd58f&"
import script from "./StaffSelect.vue?vue&type=script&lang=js&"
export * from "./StaffSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports